import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../utils/api';
import { usePortal } from '../../../context/PortalContext';
import PortalPageShell, { PortalLoading } from '../PortalPageShell';
import ChildSelector from '../ChildSelector';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

export default function PortalStudentProfile({ parentMode = false }) {
  const { studentId: routeStudentId } = useParams();
  const { student, activeStudentId, setActiveStudentId } = usePortal();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const targetId = parentMode
    ? Number(routeStudentId || activeStudentId)
    : student?.id;

  useEffect(() => {
    if (parentMode && routeStudentId) {
      setActiveStudentId(Number(routeStudentId));
    }
  }, [parentMode, routeStudentId, setActiveStudentId]);

  useEffect(() => {
    if (!targetId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/students/${targetId}/profile`);
        if (!cancelled) setProfile(res.data?.data ?? null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [targetId]);

  const s = profile?.student;
  if (loading) return <PortalLoading />;

  return (
    <PortalPageShell
      title={parentMode ? 'Student profile' : 'My profile'}
      description="Contact and guardian information"
      actions={parentMode ? <ChildSelector /> : null}
    >
      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader><CardTitle>Student</CardTitle></CardHeader>
          <CardContent className="text-sm space-y-2">
            <p><span className="text-muted-foreground">Name:</span> {s?.first_name} {s?.last_name}</p>
            <p><span className="text-muted-foreground">Admission:</span> {s?.admission_no || '—'}</p>
            <p><span className="text-muted-foreground">Class:</span> {s?.class_name} {s?.section_name ? `· ${s.section_name}` : ''}</p>
            <p><span className="text-muted-foreground">Email:</span> {s?.email || '—'}</p>
            <p><span className="text-muted-foreground">Phone:</span> {s?.phone || '—'}</p>
            <p><span className="text-muted-foreground">Address:</span> {s?.address || '—'}</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader><CardTitle>Parent / guardian</CardTitle></CardHeader>
          <CardContent className="text-sm space-y-2">
            <p><span className="text-muted-foreground">Name:</span> {s?.guardian_name || '—'}</p>
            <p><span className="text-muted-foreground">Phone:</span> {s?.guardian_phone || '—'}</p>
            <p><span className="text-muted-foreground">Email:</span> {s?.guardian_email || '—'}</p>
            <p><span className="text-muted-foreground">Relation:</span> {s?.guardian_relation || '—'}</p>
          </CardContent>
        </Card>
      </div>
    </PortalPageShell>
  );
}
